import React, { Component } from 'react';
import './GlobalMenu.css';
import Burger from './Burger'

import GlobalMenuModal from "./GlobalMenuModal";

import Menu, { SubMenu, MenuItem } from 'rc-menu';


class GlobalMenu extends Component {

    constructor(props) {
        super(props);
        this.state={ modalVisible: false, falsenewname:""}

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    handleClickOutside(event) {
        // if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        //     alert('clicked');
        //     this.setState({modalVisible:  false});
        // }
    }



    _getVisibility()
    {
        if(this.state.modalVisible)
        {
            return {visibility :"visible"};
        }
        else
        {
            return {visibility:"hidden"};
        }
    }


    _getModalStyle(event) {

        let visibility = "hidden";
        if(this.state.modalVisible)
        {
            visibility = "visible";
        }

        let out = {
            display:"block",
            left: 0,
            top: 20,
            visibility: visibility
        }
        return out;
    }

    _getModal()
    {
        return <GlobalMenuModal style={this._getModalStyle()}
                                open={this.props.open}
                                downloadLink={this.props.downloadLink}
        />
    }

    // render() {
    // return (
    //     <div ref={this.setWrapperRef}>
    //         <label  className="GlobalMenu-Command-Label"> <Burger/>
    //             <input type='button' className="GlobalMenu-Command"
    //                    onClick={(e) => {this.setState( {modalVisible : !this.state.modalVisible})}}></input>
    //         </label>
    //         {this._getModal()}
    //     </div>
    // );
    // }


    render()
    {
        return (
            <Menu>
                <MenuItem>12424</MenuItem>
                <SubMenu title="aaaaa">
                    <MenuItem>cccc</MenuItem>
                </SubMenu>
                <SubMenu title="bbbb">
                    <MenuItem>bbbbcccb</MenuItem>
                </SubMenu>
            </Menu>
        )
    }

}

// export default onClickOutside(GlobalMenu);
export default GlobalMenu;
